import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      padding: 0,
    },
    padding: '0 4%',
  },
  subContainer: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '1132px',
    alignItems: 'center',

    width: '100%',
  },
}));